import { Line, Doughnut } from 'react-chartjs-2';
import { defaultOptions } from '../../../utils/chartConfig';

const trainingData = {
  labels: ['Q1', 'Q2', 'Q3', 'Q4'],
  datasets: [{
    label: 'Completion Rate',
    data: [75, 82, 88, 92],
    borderColor: 'rgb(79, 70, 229)',
    tension: 0.4,
  }],
};

const phishingData = {
  labels: ['Reported', 'Clicked', 'Ignored'],
  datasets: [{
    data: [65, 15, 20],
    backgroundColor: [
      'rgb(34, 197, 94)',
      'rgb(239, 68, 68)',
      'rgb(234, 179, 8)',
    ],
  }],
};

export default function TrainingAwareness() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Training Completion Rates</h3>
          <div className="h-64">
            <Line data={trainingData} options={defaultOptions} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Phishing Simulation Results</h3>
          <div className="h-64">
            <Doughnut data={phishingData} options={defaultOptions} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Exercise Participation Metrics</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Table-Top Exercises</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-indigo-600">89%</p>
              <p className="text-sm text-gray-500">Participation rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">Last exercise: 2 weeks ago</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Live Simulations</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-indigo-600">76%</p>
              <p className="text-sm text-gray-500">Success rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">Next simulation: 3 days</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Training Modules</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-indigo-600">95%</p>
              <p className="text-sm text-gray-500">Completion rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">5 modules completed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}